<template>
  <div class="flex-1 min-w-[300px] max-w-[500px] p-4 border rounded-lg shadow bg-white">
    <h2
      class="mb-4 text-lg font-semibold"
      style="min-width: 500px"
    >
      {{ title }}
    </h2>

    <table class="w-full text-sm">
      <tbody class="text-gray-800">
        <tr
          v-for="(row, index) in rows"
          :key="index"
          class="border-t border-gray-200"
        >
          <td
            class="py-2"
            :colspan="row.colspan || 1"
          >
            {{ row.label }}
          </td>
          <td
            v-if="row.value !== undefined"
            class="text-right font-medium"
          >
            {{ row.value }}
          </td>
        </tr>
      </tbody>
    </table>

    <hr
      v-if="footer"
      class="my-4"
    >

    <div
      v-if="footer"
      class="text-sm text-gray-800"
    >
      <div class="flex justify-between items-center">
        <span class="label">{{ footer.label }}</span>
        <span class="font-semibold">{{ footer.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerStatusBox',
  props: {
    title: {
      type: String,
      required: true
    },
    rows: {
      type: Array,
      default: () => []
    },
    footer: {
      type: Object,
      default: null
    }
  }
}
</script>
